<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row table-responsive" style="margin: 0 !important">
        <div class="form-group margin-0">
          <div class="search-wrap">
            <div class="search-item">
              <label class="col-sm-2 control-label"> Category </label>
              <div class="col-sm-4">
                <el-select
                  v-model="searchParam.level"
                  placeholder="Select"
                  clearable
                >
                  <el-option
                    v-for="item in categoryMap"
                    :key="item.key"
                    :label="item.val"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="search-item">
              <label class="col-sm-2 control-label"> Entry Number </label>
              <div class="col-sm-4 entry-no-wrap">
                <el-input
                  v-model="entryNumberHead"
                  clearable
                  placeholder="3 Char"
                ></el-input>
                <div class="separator">-</div>
                <el-input
                  v-model="entryNumberBody"
                  clearable
                  placeholder=" 8 char"
                ></el-input>
              </div>
            </div>
            <div class="search-item">
              <label class="col-sm-2 control-label"> Judging Panel </label>
              <div class="col-sm-4">
               <el-select
                  v-model="searchParam.groupId"
                  placeholder="Select"
                  clearable
                >
                  <el-option
                    v-for="item in groupList"
                    :key="item.id"
                    :label="item.groupName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="search-item">
              <label class="col-sm-2 control-label"> Scoring Status </label>
              <div class="col-sm-4">
                <el-select
                  v-model="searchParam.judgeStatus"
                  placeholder="Select"
                  clearable
                >
                  <el-option
                    v-for="item in judgeStatusMap"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="btn-wrap">
                <el-button @click="handleSearchList" type="primary" style="width: 150px">{{
                  $t("message.Search")
                }}</el-button>
              </div>
            </div>
          </div>

           <el-table :data="JudgeOverallDetailList" :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }">
                <el-table-column type="index" label="S/N" fixed width="60">
                </el-table-column>
                <el-table-column prop="uploadCode" label="Entry Number">
                </el-table-column>
                <el-table-column prop="title" label="Name of Entry">
                </el-table-column>
                <el-table-column prop="groupName" label="Judging Panel">
                </el-table-column>
                <el-table-column prop="judgeStatus" label="Scoring Status">
                  <template slot-scope="scope">
                    <div>{{getJudgeStatusText(scope.row)}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="score" label="Score">
                  <template slot-scope="scope">
                        <div>{{scope.row.score||"-"}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="Action" width="120" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="navToDetail(scope.row)" type="primary">Details</el-button>
                    </template>
                </el-table-column>
              </el-table>
               <el-col :span="24" class="el-table_footertoolbar">
              <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handlePageSizeChange"
                @current-change="handlePageCurrentChange"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParam.pageSize"
                :total="total"
                style="float: right"
              >
              </el-pagination>
            </el-col>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../config";
import axios from "axios";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      userInfo: {
        userId: null,
        token: "",
      },
      entryNumberHead: "",
      entryNumberBody: "",
      searchParam: {
        level: "",
        entryNo: "",
        groupId: "",
        judgeStatus: "",
        sortName: "",
        sortType: "",
        pageIndex: 1,
        pageSize: 10,
      },
      groupList:[],
      total:0,
      JudgeOverallDetailList:[]
    };
  },

  created() {
    this.intiPage()
  },
  mounted() {},
  components: {},
  computed: {
    baseURL() {
      return config.domain + "/";
    },

    entryNumber() {
      if (this.entryNumberHead && this.entryNumberBody)
        return this.entryNumberHead + "-" + this.entryNumberBody;
      else if (this.entryNumberHead) return this.entryNumberHead;
      else if (this.entryNumberBody) return this.entryNumberBody;
      else return "";
    },
    judgeStatusMap(){
        return [
            {key:'Pending',value:1,tableDisplay:1},
            {key:'Completed',value:2,tableDisplay:2},
            {key:'Submitted',value:-1,tableDisplay:null}
        ]
    },
    categoryMap() {
      return [
        {key:'1',val:"Junior Primary School"},
        {key:'2',val:"Senior Primary School"},
        {key:'3',val:"Junior Secondary School"},
        {key:'4',val:"Senior Secondary School"},
      ]
    },
  },
  methods: {
    async intiPage(){
      this.getUserInfo();
      this.getGroupList()
      this.getSearchCategory()
      await this.handleSearchList()
    },
    getJudgeStatusText(row){
      const res= this.judgeStatusMap.find(i=>{
        return row.judgeStatus==i.tableDisplay
      })
      if(row.judgeStatus){
        return res?res.key+' '+`(${row.judgedCount}/${row.totalJudgeCount})`:''
      }
      return res?res.key:''
    },
    getSearchCategory(){
      this.searchParam.level=this.$route.query.navType || ''
    },
    async getGroupList(){
       const {data:{result,status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/getGroupList', {...this.userInfo})
      if(status_code=='0') {
        this.groupList=result
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    getUserInfo() {
      this.userInfo = this.getAuthObj();
    },
    navToDetail(row) {
      const res= this.judgeStatusMap.find(i=>{
        return row.judgeStatus==i.tableDisplay
      })
      const params={
        level:row.level,
        entryNumber:row.uploadCode,
        scoringStatus:res?res.key:'',
        judginPanel:row.groupName,
        stemupUploadId:row.stemupUploadId
      }
      this.$router.push({
        path: "/main/overallStatusEntryDetail",
        query: {
          ...params,
        },
      });
    },
    async handleSearchList(){
      const {data:{result,status_code,status_message}}=await axios.post(this.baseURL +'stemupJudge/getJudgeOverallDetail', {...this.searchParam,...this.userInfo,entryNo:this.entryNumber})
      if(status_code=='0') {
        this.total=result.total
        this.JudgeOverallDetailList=result.judgeEntryList
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    handlePageSizeChange(val){
        this.searchParam.pageSize = val;
        this.handleSearchList()
    },
    handlePageCurrentChange(val){
        this.searchParam.pageIndex = val;
        this.handleSearchList()
    }
  },
};
</script>

<style lang="scss" scoped>
.search-wrap{
    display:flex;
    flex-direction: column;
    .search-item{
        margin-bottom:15px;
        display:flex;
        .entry-no-wrap{
          display:flex;
          .separator{
            margin:0 10px;
            display:flex;
            align-items: center;
          }
        }
        .btn-wrap{
            display:flex;
            justify-self: flex-end;
        }
    }
}
</style>
